<style lang="scss" scoped src="./scss/exam.scss"></style>
<template>
  <div class="exam">
    <div class="exam-box">
      <div class="go-back">
        <span @click="$router.go(-1)">{{ "<返回" }}</span>
      </div>
      <div class="">
        <Title name="考试名称" fontSize="16">
          <div v-if="isShowEnterBtn">
            <el-button v-if="examInfo.hasEnd === 1" size="medium" type="info">
              考试结束
            </el-button>
            <el-button
              v-else-if="examInfo.hasBegin === 0"
              size="medium"
              type="info"
            >
              未开始
            </el-button>
            <el-button
              v-else-if="examInfo.hasJoined === 1 && examInfo.isRepeat === 0"
              size="medium"
              type="info"
            >
              已参加
            </el-button>
            <el-button
              v-else-if="examInfo.hasJoined === 1 && examInfo.isRepeat === 1"
              size="medium"
              type="primary"
              @click="enterExam(1)"
            >
              再次考试
            </el-button>
            <el-button v-else size="medium" type="primary" @click="enterExam(2)">
              进入考试
            </el-button>
          </div>
        </Title>
        <el-table
          :data="detailExam"
          :header-cell-style="{ background: '#F4F4F4', color: '#282828' }"
          border
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="endTime"
            label="考试截止时间"
            width="180"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="objectiveScore"
            label="客观题总分"
            width="180"
          >
          </el-table-column>
          <el-table-column align="center" prop="isDuration" label="时间限制">
            <template slot-scope="scope">
              <p>{{ scope.row.isDuration === 0 ? "否" : "是" }}</p>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="address" label="可参加次数">
            <template slot-scope="scope">
              <p>{{ scope.row.isRepeat === 0 ? "1次" : "无限" }}</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="exam-notice" v-if="notice.length">
          <Title name="考试须知" fontSize="16"></Title>
          <p v-for="(item, index) in notice" :key="index">
            {{ item }}
          </p>
        </div>
        <div class="exam-notice" v-if="examScore.length">
          <Title name="考试成绩" fontSize="16"></Title>
          <el-table
            :data="examScore"
            :header-cell-style="{ background: '#F4F4F4', color: '#282828' }"
            border
          >
            <el-table-column
              align="center"
              prop="dateTime"
              label="答题日期"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="useTime"
              label="所用时间"
            >
            </el-table-column>
            <el-table-column align="center" prop="totalScore" label="总分">
            </el-table-column>
            <el-table-column
              label="操作"
              align="center">
              <template slot-scope="scope">
                <el-link v-if="examInfo.isResult === 1" type="primary" @click="enterExam(3)">查看解析</el-link>
                <span v-else>无</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Title from "../../components/title";
import { examDetail } from "../../server/exam";
export default {
  name: 'examTransferPage',
  data() {
    return {
      examId: this.$route.query.examId,
      isShowEnterBtn: true,
      detailExam: [],
      examScore: [],
      notice: [],
      examInfo: {}
    };
  },
  components: {
    Title,
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getExamInfo();
  },
  methods: {
    /**
     * 获取考试信息
     */
    getExamInfo() {
      examDetail({
        examId: this.examId
      }).then(res => {
        const { code, msg, data } = res;
        if (code === 0) {
          this.examInfo = data;
          if(Object.keys(data.examScore).length > 0) {
            this.examScore.push(data.examScore);
          }
          this.notice = data.notice;
          this.detailExam.push(data);
        } else {
          this.isShowEnterBtn = false;
          this.$message.warning(msg)
        }
      });
    },

    /**
     * 进入考试
     * @param { Number } type 1-进入考试 2-再次考试
     */
    enterExam(type) {
      if (type === 1) {
        this.$confirm("重新进入考试将覆盖本次答案，是否重新考试?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.openExam();
          })
          .catch(() => {});
      } else {
        this.openExam(type);
      }
    },
    openExam(type) {
      let query = {};
      query.examId = this.examInfo.examId;
      if(type == 3) {
        query.isResult = this.examInfo.isResult;
      }
      const { href } = this.$router.resolve({
        name: "question",
        query: query
      });
      window.open(href, "_blank");
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/exam/transferPage.vue